(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('EstadoactualController', EstadoactualController);
	
	EstadoactualController.$inject = ['$scope', '$filter', 'Estadoactual'];
	
    function EstadoactualController($scope, $filter, Estadoactual) {

        var vm = this;
		vm.getLabelClass = getLabelClass;
        vm.estadoactuals = [];
		vm.listaAeropuertos = null;
		vm.seleccionAeropuerto = "<Todos>";
		vm.arrayAeropuertos = null;


		function soloUnAeropuerto()
		{
		if( !vm.seleccionAeropuerto ||	!vm.seleccionAeropuerto.length)
			return false;
		if("<Todos>" === vm.seleccionAeropuerto)
			return false;
		return true;
		}

		//exportacion a Excel/CSV
		var mystyle = {
			  sheetid: 'EstadoActualDispositivos',
			  headers:false, 
			  caption: {
				  title:'EstadoActualDispositivos',
				  style:'font-size: 50px; color:blue;' 
				},
				style:'font-size:30px',
				column: {style:{Font:{Bold:"1"}}},
				rows: {3:{style:{Font:{Color:"#FF0077"}}}},
				cells: {1:{1:{
					style: {Font:{Color:"#00FFFF"}}
				}}}
		};

		const options = {
					timeZone:"America/Argentina/Buenos_Aires",
					hour12 : false,
					hour:  "2-digit",
					minute: "2-digit",
					second: "2-digit",
					year: "numeric",
					month:"2-digit",
					day:"2-digit"
				};
				
		alasql.fn.mydateformat = function(value) {
			if (value !== "") {
				
				return new Date(value).toLocaleTimeString("es-AR",options);
			} else {
		        return ""
            }
        };
		
		function GetFormattedDate(date) {
			return new Date(date).toLocaleString("es-AR", options);
		}
	
		var ncol_fechacontrol="FechaControl";
		var ncol_aeropuerto="Aeropuerto";
		var ncol_comercio="Comercio";
		var ncol_terminal="Terminal";
		var ncol_status="Status";
		var ncol_razon="Razon";
		var ncol_metodo="Metodo";
		var ncol_impresora="Impresora";
		
		var nombrearchivoexcel= "";

		vm.exportDataExcel = function () {
						
			vm.estadoactualsfiltrada = angular.copy(vm.estadoactuals.filter($scope.filtraPorAeropuerto));			
			
			var fechaRep= GetFormattedDate(vm.estadoactualsfiltrada[0].fechacontrol);
			//01234567890123456789
			//25/06/2022, 19:10:01
			var fechaRepAAAAMMDDHHMMSS= '_'+fechaRep.substring(6,10) + fechaRep.substring(3,5) + fechaRep.substring(0,2) + '_' + fechaRep.substring(12,14) + fechaRep.substring(15,17);
			
			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= 'Aeropuerto_' + vm.estadoactualsfiltrada[0].aeropuerto.replace(/\s+/g, '-');
				}
			else {
				nombrearchivoexcel= 'Todos';
				}
									
			alasql('select * INTO XLSX("EstadoActualDispositivos_'+ nombrearchivoexcel + fechaRepAAAAMMDDHHMMSS + '",?) from ( \
				select ?,?,?,?,?,?,?,? \
				union all select mydateformat(fechacontrol),aeropuerto,comercio,nroterminal, status, razon, metodo, impresora FROM ?)', 
				[mystyle,ncol_fechacontrol,ncol_aeropuerto,ncol_comercio,ncol_terminal,ncol_status,ncol_razon,ncol_metodo, ncol_impresora, vm.estadoactualsfiltrada]);
		
			};
		
		vm.exportDataCSV = function () {
				
			vm.estadoactualsfiltrada = angular.copy(vm.estadoactuals.filter($scope.filtraPorAeropuerto));			

			var fechaRep= GetFormattedDate(vm.estadoactualsfiltrada[0].fechacontrol);
			//01234567890123456789
			//25/06/2022, 19:10:01
			var fechaRepAAAAMMDDHHMMSS= '_'+fechaRep.substring(6,10) + fechaRep.substring(3,5) + fechaRep.substring(0,2) + '_' + fechaRep.substring(12,14) + fechaRep.substring(15,17);
			//console.log(fechaRepAAAAMMDDHHMMSS);

			if(soloUnAeropuerto()==true){
				nombrearchivoexcel= 'Aeropuerto_' + vm.estadoactualsfiltrada[0].aeropuerto.replace(/\s+/g, '-');
				}
			else {
				nombrearchivoexcel= 'Todos';
				}
			
			alasql('select * INTO CSV("EstadoActualDispositivos_'+ nombrearchivoexcel + fechaRepAAAAMMDDHHMMSS + '",?) from ( \
				select ?,?,?,?,?,?,?,? \
				union all select mydateformat(fechacontrol),aeropuerto,comercio,nroterminal, status, razon, metodo, impresora FROM ?)', 
				[mystyle,ncol_fechacontrol,ncol_aeropuerto,ncol_comercio,ncol_terminal,ncol_status,ncol_razon,ncol_metodo, ncol_impresora, vm.estadoactualsfiltrada]);
		
			};
	
		function getLabelClass (statusState) {
            if (statusState === 'ERROR') {
                return 'label-danger';
            } else {
                return 'label-warning';
            }
        }
		
        function loadAll() {
            Estadoactual.query(function(result) {
                vm.estadoactuals = result;
				vm.listaAeropuertos= new Map();
				result.forEach(function(zeta){
						if(!vm.listaAeropuertos.has(zeta.aeropuerto)){				
							vm.listaAeropuertos.set(zeta.aeropuerto, true);    
							}
						})  
				vm.arrayAeropuertos = Array.from(vm.listaAeropuertos.keys());//console.log(vm.arrayAeropuertos);
				vm.arrayAeropuertos.sort();
				vm.arrayAeropuertos.unshift("<Todos>");
            });
        }
		
		$scope.filtraPorAeropuerto = function (zeta) {
			if( !$scope.vm.seleccionAeropuerto ||	!$scope.vm.seleccionAeropuerto.length)
				return true;
			if("<Todos>" === $scope.vm.seleccionAeropuerto){
				return true;
				}
			if(zeta.aeropuerto === $scope.vm.seleccionAeropuerto){
				return true;	
				}
			return false;
		}

        loadAll();
		
    }
})();
